import { Alert, AlertColor, AlertTitle, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Snackbar, Typography, CircularProgress } from "@mui/material"
import { useState } from "react"
import { isEmpty, isNil } from "lodash/fp"
import { adConfirmBankNumberUpload, adDownload, adUpload } from "./functions"
import { MuiFileInput } from "mui-file-input"
import { CloudDownloadOutlined, CloudUploadOutlined, Group, GroupOutlined, NotificationsActiveOutlined } from "@mui/icons-material"
import alertPropaties from './alert-propaties.json'
import { AlertPropaty } from "../../types"

const enum ClickButtonType {
  uploadContracts = "UploadContracts",
  confirmBankNumber = "ConfirmBankNumber"
}

export const AdAdminMenu = () => {
  const [uploadFile, setUploadFile] = useState<File | null>(null)
  const [alertPropaty, setAlertPropaty] = useState<AlertPropaty>(undefined)
  const [alertStatus, setAlertStatus] = useState<AlertColor | undefined>(undefined)
  const [isDownloading, setIsDownloading] = useState<boolean>(false)
  const [clickButtonType, setClickButtonType] = useState<string | undefined>(undefined)

  const handleInput = (uploadFile: File | null) => {
    setUploadFile(uploadFile)
  }
  const handleUploadContractsClickOpen = () => {
    handleClickOpen(ClickButtonType.uploadContracts)
  }

  const handleConfirmBankNumberClickOpen = () => {
    handleClickOpen(ClickButtonType.confirmBankNumber)
  }

  const handleClickOpen = (type: ClickButtonType) => {
    if (isNil(type)) {
      setAlertPropaty(alertPropaties['common'])
      setAlertStatus('error')
    } else {
      setClickButtonType(type)
    }
  }

  const handleClose = () => {
    setUploadFile(null)
    setClickButtonType(undefined)
  }

  const handleDownload = () => {
    setIsDownloading(true)
    adDownload().then((res: string | undefined) => {
      setAlertPropaty(alertPropaties['download'])
      if (isNil(res)) {
        setAlertStatus("error")
        setIsDownloading(false)
      } else {
        setAlertStatus("success")
        setIsDownloading(false)
      }
    })
  }

  const handleSubmit = async (uploadFile: File | null) => {
    if (!isNil(uploadFile)) {
      setAlertPropaty(alertPropaties['upload'])
      if (clickButtonType === ClickButtonType.uploadContracts) {
        adUpload(uploadFile).then((result) => {
          if (result) {
            setAlertStatus("success")
          } else {
            setAlertStatus("error")
          }
        }).catch((error) => {
          setAlertStatus("error")
        })
      }
      if (clickButtonType === ClickButtonType.confirmBankNumber) {
        adConfirmBankNumberUpload(uploadFile).then((result) => {
          if (result) {
            setAlertStatus("success")
          } else {
            setAlertStatus("error")
          }
        }).catch((error) => {
          setAlertStatus("error")
        })
      }

    } else {
      setAlertStatus("error")
    }
    handleClose()
  }

  const handleAlertClose = () => {
    setAlertStatus(undefined)
    setAlertPropaty(undefined)
  }

  return (
    <Box display="grid" justifyContent={"center"}>
      <Typography variant="h6" borderBottom={2} borderColor={"GrayText"} color="gray">地震保険契約の確認・変更</Typography>
      <Box display={"flex"} justifyContent={"center"}>
        <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} marginTop={3}>
          <Box display="grid" paddingTop={3} color="gray">
            <Typography display={"flex"} alignContent={"center"}><Group />地震保険契約の確認(CSVファイルをダウンロード)</Typography>
            <Button variant="contained" sx={{ marginY: 1, color: "#FFFFFF", backgroundColor: "#006c60" }} onClick={handleDownload} disabled={isDownloading}><CloudDownloadOutlined />ダウンロード{isDownloading ? <CircularProgress size={20} color="inherit" /> : ""}</Button>
          </Box>
          <Box display="grid" paddingTop={3} color="gray">
            <Typography display={"flex"} alignContent={"center"}><GroupOutlined />地震保険契約の変更（CSVファイルをアップロード）</Typography>
            <Button variant="contained" onClick={handleUploadContractsClickOpen} sx={{ marginY: 1, color: "#FFFFFF", backgroundColor: "#006c60" }}><CloudUploadOutlined />アップロード</Button>
          </Box>
          <Box display="grid" paddingTop={3} color="gray">
            <Typography display={"flex"} alignContent={"center"}><NotificationsActiveOutlined />口座番号の再登録通知（CSVファイルをアップロード）</Typography>
            <Button variant="contained" onClick={handleConfirmBankNumberClickOpen} sx={{ marginY: 1, color: "#FFFFFF", backgroundColor: "#006c60" }}><CloudUploadOutlined />アップロード</Button>
          </Box>
        </Box>
      </Box>

      <Dialog
        open={!isNil(clickButtonType)}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault()
            handleClose()
          }
        }}
      >
        <DialogTitle>ファイルアップロード</DialogTitle>
        <DialogContent>
          <DialogContentText>
            csvファイルを選択してください。
          </DialogContentText>
          <MuiFileInput value={uploadFile} onChange={handleInput} variant="outlined" />
          <br />
          <Typography variant="caption" component="div" gutterBottom>csv ファイルのみ、ファイルサイズは5MB以内。</Typography>
          {!(uploadFile) && (
            <Typography variant="caption" component="div" color="error.main" gutterBottom>ファイルを選択してください。</Typography>)}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>キャンセル</Button>
          <Button type="submit" onClick={async () => handleSubmit(uploadFile)} disabled={isNil(uploadFile)}>送信</Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={!isEmpty(alertStatus)} autoHideDuration={5000} onClose={handleAlertClose}>
        <Alert severity={alertStatus}>
          <AlertTitle>{!isEmpty(alertStatus) && !isNil(alertPropaty) ? alertPropaty[alertStatus as keyof typeof alertPropaty]["alertTitle"] : ""}</AlertTitle>
          {!isEmpty(alertStatus) && !isNil(alertPropaty) ? alertPropaty[alertStatus as keyof typeof alertPropaty]["alertMessage"] : ""}
        </Alert>
      </Snackbar>
    </Box>
  )
}